<template>
	<div>
		<div v-for="(option, okey) in datapoints" :key="okey" class="row m-0 mb-1">
			<div class="col-3 p-0">
				<input name="optionid[]" class="form-control" v-model="option.id" :placeholder="$t('id')" />
			</div>
			<div class="col-4 p-0">
				<input name="optioncaption[]" class="form-control" v-model="option.caption" :placeholder="$t('caption')" />
			</div>
			<div class="col-3 p-0">
				<select
					v-model="option.color"
					class="form-control"
				>
					<option value="">{{$t('auto')}}</option>
					<option v-for="(hex, color) in $config.getColors()" :key="color" :value="color">{{$t(color)}}</option>
				</select>
			</div>
			<div class="col-2 p-0">
				<a class="btn btn-light" @click="removeDatum(okey)"><b-icon icon="trash" width="1em" height="1em"></b-icon></a>
			</div>
		</div>
		<div>
			<button class="btn btn-light" @click="addDatum"><b-icon icon="plus" width="1em" height="1em"></b-icon> {{ $t('add') }}</button>
		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	name: 'DataPointEditor',
	props: ['datapoints'],
	data() {
		return {
		}
	},
	methods: {
		addDatum() {
			//if (field.options == undefined) field.options = [];
			this.$set(this.datapoints, this.datapoints.length, {
				id: '' ,
				caption: '' ,
				value: 0 ,
				color: ''
			});
			this.$forceUpdate();
		},
		removeDatum( itemIndex) {
			this.$delete(this.datapoints, itemIndex)
			this.$forceUpdate();
		}
	},
	computed: {

	}
};
</script>
